/** Standard error definition */

export const INVALID_USER_DATA = 'invalid_grant';
